import React from "react";
import { IAdHocProject, IAsset, IProject } from "../../../../models/applicationState";
import { Checkbox, FontIcon, Spinner, SpinnerSize } from "@fluentui/react";
import { ContentSource } from "../../common/assetPreview/assetPreview";
import { AssetPreview } from "./assetPreview";

export interface IEditorSideBarItemQueuedProps {
    asset?: IAsset;
    style: any;
    getAssetCssClassNames: (asset: IAsset, selectedAsset?: IAsset) => string;
    selectedAsset?: IAsset;
    checkboxRowRenderer?: (asset: IAsset) => JSX.Element;
    renderBadges: (asset: IAsset) => JSX.Element;
    onAssetLoaded?: (asset: IAsset, ContentSource: ContentSource) => void;
    assetTitle?: string;
    projectId: string;
    adHocProject: IAdHocProject;
    loadAdHocOcrProject: (requestId: string) => Promise<void>;
    selectedRequestId?: string;
    groupId?: string;
}

export interface IEditorSideBarItemQueuedState {
    isVisible: boolean
}

export default class EditorSideBarItemQueued extends React.Component<IEditorSideBarItemQueuedProps, IEditorSideBarItemQueuedState> {
    private panelRef: React.RefObject<any> = React.createRef();
    constructor(props: IEditorSideBarItemQueuedProps) {
        super(props);

        this.state = {
            isVisible: true
        };
        this.initializeIntersectionObserver = this.initializeIntersectionObserver.bind(this);
    }

    componentDidMount() {
        //this.initializeIntersectionObserver();
    }

    initializeIntersectionObserver() {
        if (!('IntersectionObserver' in window)) {
            //console.error('IntersectionObserver not supported');
        }

        const intersectionObserver = new IntersectionObserver(
            (entries: IntersectionObserverEntry[], observer: IntersectionObserver) => {
                entries.forEach((entry, i) => {
                    if (!entry.isIntersecting) return;

                    observer.unobserve(entry.target);

                    this.setState({
                        isVisible: true,
                    });
                });
            }
        );

        intersectionObserver.observe(this.panelRef.current);
    }

    public render() {
        const { style, getAssetCssClassNames, selectedAsset, checkboxRowRenderer, renderBadges, onAssetLoaded, assetTitle } = this.props;
        const asset = Object.values(this.props.adHocProject.project.assets)[0];
        let cssName = this.props.adHocProject.project.id === this.props.selectedRequestId ? 'asset-item-image-selected' : 'asset-item-image';
        const isSelected = this.props.adHocProject.project.id === this.props.selectedRequestId;
        return (            
            <div
                ref={this.panelRef}
                key={this.props.adHocProject.project.id}
                // style={{ position: "relative" }}
                style={{
                    padding: "15px",
                    marginBottom: "10px",
                    border: isSelected ? "2px solid #0078d4" : "2px solid #cce7ff", // Blue border for selected and light blue for unselected
                    borderRadius: "8px", // Rounded corners for a modern look
                    backgroundColor: isSelected ? "#e6f7ff" : "#f4faff", // Light blue background for selected and lighter blue for unselected
                    boxShadow: isSelected
                        ? "0 4px 8px rgba(0, 120, 212, 0.2)" // Subtle shadow for selected item
                        : "0 4px 8px rgba(0, 0, 0, 0.1)", // Default shadow for unselected items
                    transition: "all 0.2s ease-in-out", // Smooth transition for hover and selection effects
                    cursor: "pointer", // Pointer cursor to indicate clickability
                    position: "relative"
                }}
                role="row"
                //className={getAssetCssClassNames(asset, selectedAsset)}
                // onClick={() => this.props.loadAdHocOcrProject(this.props.adHocProject.project.id)}
            >
                {this.props && this.props.adHocProject &&
                    <React.Fragment>
                        <div
                            style={{
                                position: "absolute",
                                top: 0,
                                left: 0,
                                width: "100%",
                                height: "100%",
                                backgroundColor: "rgba(255, 255, 255, 0.7)", // Semi-transparent white background
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                zIndex: 10, // Ensure it appears above other content
                            }}
                        >
                            <Spinner
                                size={SpinnerSize.large}
                                label="Processing, Please wait..."
                                ariaLive="assertive"
                                labelPosition="bottom"
                                styles={{
                                    root: {
                                        color: "#0078d4", // Blue spinner color
                                    },
                                    label: {
                                        fontSize: "16px", // Slightly larger font for better readability
                                        color: "#333", // Dark gray text color
                                    },
                                }}
                            />
                        </div>
                        <div 
                            className={isSelected ? "asset-item-image-selected" : "asset-item-image"}
                            role="gridcell"
                            //onClick={() => this.props.loadAdHocOcrProject(this.props.adHocProject.project.id)}
                            style={{                                
                                backgroundColor: isSelected ? "#0078d4" : "#cce7ff", // Blue background for selected and light blue for unselected
                                color: isSelected ? "#ffffff" : "#004578", // White text for selected, dark blue for unselected
                                //padding: "10px",
                                borderRadius: "5px", // Rounded corners for the asset preview
                                textAlign: "center",
                                //fontWeight: isSelected ? "bold" : "normal", // Bold text for selected item
                                transition: "all 0.2s ease-in-out", // Smooth transition for hover and selection effects
                            }}
                        >                            
                            <AssetPreview
                                project={this.props.adHocProject.project}
                            />
                        </div>
                        <div className="asset-item-metadata" role="rowheader">
                            <span className="asset-filename" title="123">
                                {asset.name}
                            </span>                            
                        </div>
                    </React.Fragment>
                }
            </div>
        );
    }
}
